/**
 * Where to go right after a sign-in. Pure so it can be unit tested.
 *
 * An account that already has a profile always wins over an onboarding draft:
 * a returning mother who tapped "Get started" by mistake must never have her
 * real profile overwritten by what she typed this time.
 */
export type AfterSignIn =
  | { to: 'home'; discardDraft: boolean }
  | { to: 'hospital'; commitDraft: true }
  | { to: 'how' };

export function afterSignInRoute(hasDraft: boolean, accountHasProfile: boolean): AfterSignIn {
  if (accountHasProfile) return { to: 'home', discardDraft: hasDraft };
  if (hasDraft) return { to: 'hospital', commitDraft: true };
  return { to: 'how' };
}
